<!-- TEXTBOX -->
@if (entry.base?.display) {
  <form
    [connect]="'payloadStates.' + entry?.formControlAttributes?.connectPath"
    class="question-class"
    [formGroup]="form"
    >
    <mat-form-field appearance="outline">
      <mat-label>{{entry?.formControlAttributes?.label}}@if (entry?.formControlAttributes?.required) {
        <span style="color: #a71919;">*</span>
      }</mat-label>
      <mat-select [aria-label]="entry?.formControlAttributes?.label" [formControlName]="entry?.formControlAttributes?.formControlName"
        [id]="entry?.formControlAttributes?.connectPath + '-' + entry?.formControlAttributes?.formControlName"
        (selectionChange)="agencyChange($event.value)"
        [compareWith]="trackAgencyComparison">
        @for (option of availableAgencies; track option) {
          <mat-option [value]="option">{{option.agencyName + '-' + option.region}}</mat-option>
        }
      </mat-select>
      @if (formControls[entry?.formControlAttributes?.formControlName]?.errors?.required) {
        <mat-error>Required</mat-error>
      }
      @if (formControls[entry?.formControlAttributes?.formControlName]?.errors?.regionMismatch) {
        <mat-error>
          Selected agency region does not match the zipcode
        </mat-error>
      }
    </mat-form-field>
  </form>
}
